export const EVENT_MSGS_UPDATE = '_event_msgs_update';


// WEBPACK FOOTER //
// ./src/app/util/emitter-service/nome-evento.ts